import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import { Layout } from "antd";
import LayoutHeader from "./layoutHeader";
import ProtectedRoute from "./ProtectedRoute";
import SideBaruser from "./sideBar";
import Receptionist from "../receptionist/receptionist";
import ReceptionistProfile from "../receptionist/profile/receptionistProfile";
import VisitorsDetails from "../receptionist/visitorsDetails/visitorsDetails";
import TelecallerIndex from "../receptionist/telecallerDetails/telecallerIndex";
import UpdateVisitors from "../receptionist/visitorsDetails/updateVisitors";
import ProjectIndex from "../receptionist/projectDetails/projectIndexx";
import TaskDetatils from "../receptionist/projectDetails/taskDetatils";
import TelecallerIndexDashboard from "../telecaller/telecaller";
import TelecallerProfile from "../telecaller/TelecallerProfile/telecallerProfile";
import TelecallerProject from "../telecaller/telecallerProjectDetais/telecallerProject";
import TelecallerTaskDetails from "../telecaller/TelecallerProfile/telecallerTask";
import TelecallerWrok from "../telecaller/telecallerWrok/telecallerWrok";
import TelecallerwrokUpdate from "../telecaller/telecallerWrok/telecallerwrokUpdate";
import LeaveDetails from "../telecaller/leaveDetails/leaveDetails";
import Salary_Details from "../telecaller/TelecallerProfile/salary_Details";

const TelecallerNavigation = () => {
  const user = useSelector((state: any) => state.user);
  const [collapsed, setCollapsed] = useState(false);
  const { Sider, Content } = Layout;

  return (
    <Layout>
      <Sider
        style={{ backgroundColor: "#FF1A1A", height: "100vh" }}
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={collapsed ? 40 : 250}
      >
        <SideBaruser
          collapsed={collapsed}
          doCollapse={() => setCollapsed(!collapsed)}
        />
      </Sider>
      <Layout>
        <LayoutHeader />
        <Content style={{ background: "#fff" }}>
          <Routes>
            <Route path="/" element={<TelecallerIndexDashboard />} />

            <Route
              path="/TelecallerDashboard"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <TelecallerIndexDashboard />
                </ProtectedRoute>
              }
            />

            <Route
              path="/Telecaller_Profile"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <TelecallerProfile />
                </ProtectedRoute>
              }
            />

            <Route
              path="/Visitors"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <VisitorsDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Telecaller_Details"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <TelecallerWrok />
                </ProtectedRoute>
              }
            />
            <Route
              path="/TelecallerWrokUpdate_details/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <TelecallerwrokUpdate />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Project_Details"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <TelecallerProject />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Project_Details/view_task_Details/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <TelecallerTaskDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Leave_Details"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <LeaveDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/viewSalaryDetails"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <Salary_Details />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default TelecallerNavigation;
